






























import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component
export default class ReadAndAccept extends Vue {
  accepted: boolean = false

  @Prop({ required: true })
  readonly rules!: string

  @Emit('next')
  onNext() {
    return this
  }

  reset() {
    this.accepted = false
  }
}
